import React from 'react';
import cx from 'classnames';
import pick from 'lodash/pick';
import ContentIcon from '../ContentIcon/index.js';
import UnitList from '../UnitList/index.js';
import ContentBadges from '../lib/ContentBadges.js';
import ContentButtons from '../lib/ContentButtons.js';
import ContentInformation from '../lib/ContentInformation.js';
import ContentPreviewIndicator from '../lib/ContentPreviewIndicator.js';
import ContentProgress from '../lib/ContentProgress.js';
import contentType, { defaultContentType } from '../lib/types/content.js';
import CredentialRegistrationButton from '../lib/CredentialRegistrationButton.js';
import CustomStepButton from '../lib/CustomStepButton.js';
import labelsForUnitList from '../lib/labelsForUnitList.js';
import withAutomaticColorCalculation from '../lib/withAutomaticColorCalculation.js';

const ContentTile = ({
  buttons,
  className,
  content,
  credential,
  eventHandlers,
  labels,
  trackEvent,
  user,
  units,
  unitsInitiallyExpanded
}) => /*#__PURE__*/React.createElement("div", {
  className: className
}, /*#__PURE__*/React.createElement("div", {
  style: {
    borderTopColor: content.color
  },
  className: "tds-content-tile slds-text-body_small tds-color_meteorite slds-is-relative"
}, /*#__PURE__*/React.createElement("div", {
  className: cx("tds-content-panel_body ", {
    "slds-border_bottom": units
  })
}, content.preview && /*#__PURE__*/React.createElement(ContentPreviewIndicator, {
  labels: labels,
  id: content.apiName,
  namespace: content.preview.namespace,
  releasedAt: content.preview.releasedAt,
  updatedAt: content.preview.updatedAt
}), /*#__PURE__*/React.createElement("div", {
  className: "slds-float_right slds-text-align_right"
}, /*#__PURE__*/React.createElement(ContentBadges, {
  content: content,
  user: user,
  labels: labels
})), /*#__PURE__*/React.createElement(ContentIcon, {
  content: {
    ...pick(content, ["color", "image", "path", "trailmix", "type", "apiName", "subTitle", "unitCount"])
  },
  user: pick(user, ["finishedAt", "unlocked", "completedCount"]),
  noLink: content.path == null || content.path === "",
  trackEvent: trackEvent
}), /*#__PURE__*/React.createElement(ContentInformation, {
  content: content,
  className: "slds-m-vertical_small",
  fixedHeight: true,
  noLink: content.path == null || content.path === "",
  trackEvent: trackEvent
}), /*#__PURE__*/React.createElement("div", {
  className: cx("slds-grid", {
    "slds-grid_align-end": content.type === "customstep"
  }),
  style: {
    minHeight: "2.5rem"
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "slds-grow tds-content__buttons"
}, buttons && /*#__PURE__*/React.createElement(ContentButtons, {
  buttons: buttons
})), /*#__PURE__*/React.createElement("div", {
  className: "slds-grow-none slds-grid slds-grid_vertical-align-center slds-text-align_right"
}, content.type === "credential" && /*#__PURE__*/React.createElement(CredentialRegistrationButton, {
  credential: credential,
  labels: labels
}), content.type !== "credential" && /*#__PURE__*/React.createElement(ContentProgress, {
  content: content,
  user: user,
  labels: labels
}), content.type === "customstep" && content.manualCompletion === true && /*#__PURE__*/React.createElement(CustomStepButton, {
  markAsCompleteLabel: labels.markAsComplete,
  buttonLabel: labels.buttonLabel,
  completedOn: user && user.finishedAt,
  completedLabel: labels.completed,
  clickHandler: eventHandlers && eventHandlers.completeCustomStepHandler
})))), /*#__PURE__*/React.createElement("div", null, units && /*#__PURE__*/React.createElement(UnitList, {
  units: units,
  initiallyCollapsed: !unitsInitiallyExpanded,
  labels: labelsForUnitList(content.type, labels),
  parentApiName: content.apiName,
  collapsible: true
}))));
ContentTile.displayName = "ContentTile";
ContentTile.propTypes = contentType;
ContentTile.defaultProps = defaultContentType;
const ContentTileContainer = withAutomaticColorCalculation(ContentTile);
ContentTileContainer.propTypes = contentType;
ContentTileContainer.defaultProps = defaultContentType;
var ContentTile$1 = ContentTileContainer;

export { ContentTile$1 as default };
